// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"1e1e5c2a","652":"ff4dbe0a","787":"d0830279"}[chunkId] + ".chunk.js";
};